export const FOREIGN_TRADE_BY_PRODUCTS = 'foreignTradeByProducts';

export const FOREIGN_TRADE_BY_PRODUCTS_ACTIONS_NAME = {
  searchProductAggregated: `${FOREIGN_TRADE_BY_PRODUCTS}/searchProductAggregated`,
} as const;

export const FOREIGN_TRADE_BY_PRODUCTS_MUTATIONS_NAME = {
  setProductAggregated: `${FOREIGN_TRADE_BY_PRODUCTS}/setProductAggregated`,
} as const;

export const FOREIGN_TRADE_BY_PRODUCTS_GETTERS_NAME = {
  getProductAggregated: `${FOREIGN_TRADE_BY_PRODUCTS}/getProductAggregated`,
} as const;
